// extracted by mini-css-extract-plugin
module.exports = {"preview-banner":"preview-banner_preview-banner__Lk0L7","text":"preview-banner_text__xoAiE"};